"use strict";

import angular from "angular";

import { StringUtils } from "../../utils/string.utils";
import { DocumentUtils } from "../../utils/document/document.utils";

const CNPJ_PATTERN = "NN.NNN.NNN/NNNN-00";
const CPF_PATTERN = "000.000.000-00";

function nucontCpfCnpjMaskDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
            function format(cleanValue) {
                const isCnpj =
                    cleanValue.length > 11 || /[A-Z]/.test(cleanValue);
                const pattern = isCnpj ? CNPJ_PATTERN : CPF_PATTERN;
                return StringUtils.stringMaskApply(cleanValue, pattern, {});
            }

            ctrl.$formatters.push(function (value) {
                if (ctrl.$isEmpty(value)) return value;
                return format(DocumentUtils.clean(value));
            });

            ctrl.$parsers.push(function (value) {
                if (ctrl.$isEmpty(value)) return value;
                const cleanValue = DocumentUtils.clean(value);
                const maskedValue = format(cleanValue);
                if (ctrl.$viewValue !== maskedValue) {
                    ctrl.$setViewValue(maskedValue);
                    ctrl.$render();
                }
                return cleanValue;
            });

            ctrl.$validators.document = function (modelValue) {
                return (
                    ctrl.$isEmpty(modelValue) ||
                    DocumentUtils.isValidDocument(modelValue)
                );
            };
        }
    };
}

const name = "nucontCpfCnpjMask";
const factory = nucontCpfCnpjMaskDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
